import e from "../../../../../../../_virtual/index3.js";
function compare(e2, t) {
  return e2.a === t.a ? e2.b === t.b ? e2.c - t.c : e2.b - t.b : e2.a - t.a;
}
function selectorSpecificity(t, s) {
  if (!t) return { a: 0, b: 0, c: 0 };
  let c = 0, n = 0, o = 0;
  if ("universal" == t.type) return { a: 0, b: 0, c: 0 };
  if ("id" === t.type) c += 1;
  else if ("tag" === t.type) o += 1;
  else if ("class" === t.type) n += 1;
  else if ("attribute" === t.type) n += 1;
  else if (isPseudoElement(t)) switch (t.value.toLowerCase()) {
    case "::slotted":
      if (o += 1, t.nodes && t.nodes.length > 0) {
        const e2 = specificityOfMostSpecificListItem(t.nodes);
        c += e2.a, n += e2.b, o += e2.c;
      }
      break;
    case "::view-transition-group":
    case "::view-transition-image-pair":
    case "::view-transition-old":
    case "::view-transition-new":
      return t.nodes && 1 === t.nodes.length && "selector" === t.nodes[0].type && selectorNodeContainsNothingOrOnlyUniversal(t.nodes[0]) ? { a: 0, b: 0, c: 0 } : { a: 0, b: 0, c: 1 };
    default:
      o += 1;
  }
  else if (e.isPseudoClass(t)) switch (t.value.toLowerCase()) {
    case ":-webkit-any":
    case ":any":
    default:
      n += 1;
      break;
    case ":-moz-any":
    case ":has":
    case ":is":
    case ":matches":
    case ":not":
      if (t.nodes && t.nodes.length > 0) {
        const e2 = specificityOfMostSpecificListItem(t.nodes);
        c += e2.a, n += e2.b, o += e2.c;
      }
      break;
    case ":where":
      break;
    case ":nth-child":
    case ":nth-last-child":
      if (n += 1, t.nodes && t.nodes.length > 0) {
        const i = t.nodes[0].nodes.findIndex(((e2) => "tag" === e2.type && "of" === e2.value.toLowerCase()));
        if (i > -1) {
          const a = e.selector({ nodes: [], value: "" });
          t.nodes[0].nodes.slice(i + 1).forEach(((e2) => {
            a.append(e2.clone());
          }));
          const r = [a];
          t.nodes.length > 1 && r.push(...t.nodes.slice(1));
          const l = specificityOfMostSpecificListItem(r);
          c += l.a, n += l.b, o += l.c;
        }
      }
      break;
    case ":local":
    case ":global":
      t.nodes && t.nodes.length > 0 && t.nodes.forEach(((e2) => {
        const t2 = selectorSpecificity(e2);
        c += t2.a, n += t2.b, o += t2.c;
      }));
      break;
    case ":host":
    case ":host-context":
      if (n += 1, t.nodes && t.nodes.length > 0) {
        const e2 = specificityOfMostSpecificListItem(t.nodes);
        c += e2.a, n += e2.b, o += e2.c;
      }
      break;
    case ":active-view-transition":
    case ":active-view-transition-type":
      return { a: 0, b: 1, c: 0 };
  }
  else e.isContainer(t) && t.nodes?.length > 0 && t.nodes.forEach(((e2) => {
    const t2 = selectorSpecificity(e2);
    c += t2.a, n += t2.b, o += t2.c;
  }));
  return { a: c, b: n, c: o };
}
function specificityOfMostSpecificListItem(e2, t) {
  let s = { a: 0, b: 0, c: 0 };
  return e2.forEach(((e3) => {
    const i = selectorSpecificity(e3);
    compare(i, s) < 0 || (s = i);
  })), s;
}
function isPseudoElement(t) {
  return e.isPseudoElement(t);
}
function selectorNodeContainsNothingOrOnlyUniversal(e2) {
  if (!e2) return false;
  if (!e2.nodes) return false;
  const t = e2.nodes.filter(((e3) => "comment" !== e3.type));
  return 0 === t.length || 1 === t.length && "universal" === t[0].type;
}
export {
  compare,
  selectorSpecificity,
  specificityOfMostSpecificListItem
};
//# sourceMappingURL=index.js.map
